import { apiClient, API_PRX } from '@indipia/shared';

export interface SiteTodayProcessItem {
  processTitle: string;
  processDayNumber: number | null;
}

export interface SiteTodayOrderItem {
  orderMaterialName: string;
  orderDueInDays: number | null;
  orderVendorName: string | null;
}

/** GET /indipia/studio/site-today 응답 data — 인디플래너 팬아웃 결과(다건, 없으면 빈 배열) */
export interface SiteTodayContent {
  processes: SiteTodayProcessItem[];
  orders: SiteTodayOrderItem[];
}

export interface SiteTodayItem {
  siteId: number;
  /** 인디플래너 팬아웃 실패·미구현 시 null (전체 실패 처리 없음 — 이 항목만 비어있음) */
  content: SiteTodayContent | null;
}

/**
 * 스튜디오 홈 현장카드 "오늘 작업공정/발주공정" 배치 조회.
 * sv-indipia가 siteId당 그날 자정까지 캐시하므로 FE는 그냥 매번 호출하면 된다(스튜디오홈_현장카드_플랫폼공통API_요청.md §1).
 */
export async function fetchSiteTodays(siteIds: number[]): Promise<SiteTodayItem[]> {
  if (siteIds.length === 0) return [];
  const res = await apiClient.get(`${API_PRX.INDIPIA}/studio/site-today`, {
    params: { siteIds: siteIds.join(',') },
  });
  return (res.data.data ?? []) as SiteTodayItem[];
}
